export default {
  name: "UserCircleSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M5.69 25.44A13.94 13.94 0 0 1 2 16C2 8.28 8.28 2 16 2s14 6.28 14 14c0 3.64-1.41 6.95-3.69 9.44-.66-3.52-3.02-5.51-5.56-6.52A6.51 6.51 0 0 0 15.99 8a6.51 6.51 0 0 0-4.75 10.92c-2.54 1.02-4.89 3-5.55 6.52zM23.5 27.5c0-6.19-6.25-6.5-7.5-6.5s-7.5.31-7.5 6.5v.3a13.94 13.94 0 0 0 15 0v-.3zm-11.01-13a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0z",
  },
}
